import { find } from 'lodash-es';
import { ADD_CAROUSEL_IN_STORE, ADD_NEW_VIDEOS_IN_STORE, REQUEST_NEW_VIDEOS, updateCarousel } from 'pages/home.page';

export const videoCarouselReducer = (state = [], action) => {
  switch (action.type) {
    case ADD_CAROUSEL_IN_STORE:
      if (!!find(state, ['channelId', action.payload.channelId])) {
        return updateCarousel(
          state,
          action.payload.channelId,
          action.payload.pageNum,
          action.payload.perPage,
          action.payload.videos.slice(0, action.payload.perPage),
          action.payload.isLoading,
          action.payload.position,
          action.payload.totalNumberOfVideos,
          true
        );
      }
      return [
        ...state,
        {
          channelId: action.payload.channelId,
          pageNum: action.payload.pageNum,
          perPage: action.payload.perPage,
          videos: action.payload.videos,
          position: action.payload.position,
          totalNumberOfVideos: action.payload.totalNumberOfVideos,
          isLoading: action.payload.isLoading,
        },
      ];
    case REQUEST_NEW_VIDEOS:
      return updateCarousel(
        state,
        action.payload.channelId,
        action.payload.pageNum + 1,
        null,
        null,
        null,
        action.payload.position + action.payload.numOfVideosToShift,
        null
      );
    case ADD_NEW_VIDEOS_IN_STORE:
      return updateCarousel(state, action.payload.channelId, null, null, action.payload.videos, null, null, null, null);
    default:
      return state;
  }
};
